/**
 * @copyright WaterStreet. All rights reserved.
 */

import {
	HttpClient
} from '@angular/common/http';
import {
	Inject,
	Injectable
} from '@angular/core';
import {
	IRulePresentationDefinitionDto
} from '@api/interfaces/rules/rule-presentation-definition.dto.interface';
import {
	BaseEntityApiService
} from '@api/services/base/base-entity.api.service';
import {
	AppConstants
} from '@shared/constants/app.constants';
import {
	CacheService
} from '@shared/services/cache.service';

/**
 * A class representing the logic and services of the rule presentation
 * definition controller.
 *
 * @export
 * @class RulePresentationDefinitionApiService
 * @extends {BaseEntityApiService<IRulePresentationDefinitionDto>}
 */
@Injectable()
export class RulePresentationDefinitionApiService
	extends BaseEntityApiService<IRulePresentationDefinitionDto>
{
	/**
	 * Creates an instance of a RulePresentationDefinitionApiService.
	 *
	 * @param {HttpClient} HttpClient
	 * The injected http client to use in the base api service.
	 * @param {CacheService} cache
	 * The injected cache service to use in the base api service.
	 * @memberof RulePresentationDefinitionApiService
	 */
	public constructor(
		@Inject(HttpClient) http: HttpClient,
		@Inject(CacheService) cache: CacheService)
	{
		super();
		this.httpClient = http;
		this.cacheService = cache;
		this.endpoint =
			AppConstants.apiControllers.rulePresentationDefinitions;
	}
}